import { BrandCompetitorSchema } from "@redotech/redo-agents-common/aeo-agents/brand-competitor";
import * as z from "zod";

export const getBrandCompetitors = {
  name: "getBrandCompetitors" as const,
  input: z.object({}),
  output: z.object({ competitors: z.array(BrandCompetitorSchema) }),
};
